import type { IconAsset } from '../Icon.types';

const code = (
  <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
    <g>
      <polygon points='0 0 24 0 24 24 0 24'></polygon>
      <g transform='translate(2.000000, 2.000000)'>
        <polygon points='0 0 21.6 0 21.6 21.6 0 21.6'></polygon>
      </g>
      <path
        d='M12.1715627,2.00054908 C10.2921329,1.97716275 8.48045341,2.70165358 7.13538936,4.01451536 C5.79032531,5.32737714 5.02215455,7.1209722 5,9.00041694 C5,14.2497175 12.1715627,22 12.1715627,22 C12.1715627,22 19.3431255,14.2473162 19.3431255,9.00041694 C19.3209709,7.1209722 18.5528001,5.32737714 17.2077361,4.01451536 C15.862672,2.70165358 14.0509925,1.97716275 12.1715627,2.00054908 L12.1715627,2.00054908 Z M12.1715627,11.5001982 C10.798451,11.4672287 9.70886815,10.3330828 9.73093685,8.95975262 C9.75300554,7.58642245 10.8784667,6.48787109 12.2519287,6.4990376 C13.6253908,6.51020412 14.7328415,7.62690949 14.7325779,9.00041694 C14.7147818,10.3975372 13.5687045,11.5162118 12.1715627,11.5001982 L12.1715627,11.5001982 Z'
        fill='currentColor'
      />
    </g>
  </g>
);

export const location: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
  bold: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
